import React, { useEffect, useRef, useState } from "react";
import { isEmpty, isEqual } from "lodash";
import {
  SUMMARY_PAYMENT_PETTY_CASHIER,
  SUMMARY_RECEIVE_PETTY_CASHIER,
  SUMMARY_RECEIVE_MANAGER,
  SUMMARY_PAYMENT_MANAGER
} from "../../constants/urls";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Table from "../summaryForm/components/table/table";
import {
  normalizeData,
  PAYMENT_AND_RECEIVE,
  PAYMENT_AND_RECEIVE_DETAIL_HEADER
} from "../summaryForm/components/table/normalizer";
import { BoxLoading } from "../../components/loading";
import ErrorHandle from "../../components/error/mainError";
import { TYPE } from "../../constants/filters";
import { PETTY_CASHIER_SUMMARY_TRANSACTIONS_TABS } from "../../constants/tabs";

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
export default Wdata => {
  const TransactionsItem = props => {
    const {
      getList,
      match: {
        params: { id }
      },
      data,
      meta,
      loading,
      error,
      mainLoading,
      history
    } = props;
    const [dataList, setDataList] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [hasMorePage, setHasMorePage] = useState(true);

    const isFirstRender = useRef(true);
    const getRequest = (nextPage = 1) => {
      const searchParam = new URLSearchParams(history.location.search);

      const renderCondition =
        searchParam.get(TYPE) === undefined ||
        searchParam.get(TYPE) === null ||
        parseInt(searchParam.get(TYPE)) ===
          PETTY_CASHIER_SUMMARY_TRANSACTIONS_TABS.keys.DETAILS;
      if (renderCondition) {
        getList(id, nextPage);
      }
    };

    useEffect(() => {
      getRequest();
    }, []);

    const prevData = usePrevious(data);
    const prevSearch = usePrevious(history.location.search);

    useEffect(() => {
      if (isFirstRender.current) {
        isFirstRender.current = false;
      } else {
        if (!isEqual(prevData, data) && !isEmpty(data)) {
          setDataList([...dataList, ...data]);
        }
        // if (prevSearch !== history.location.search) {
        //   if (
        //       history.location.pathname ===
        //       `${SUMMARY_PETTY_CASH_PETTY_CASHIER}/${id}` // when get file, route changed and if this condition is not checked, this scope runs
        //   ) {
        //     getRequest();
        //     setPageNumber(1);
        //     setHasMorePage(true);
        //     setDataList([]);
        //   }
        // }
      }
    }, [history.location.search, data]);

    const paginationClickHandler = () => {
      let currentPage = error ? pageNumber : meta.current_page;
      let nextPage = error ? currentPage : currentPage + 1;
      if (meta && meta.last_page !== undefined) {
        if (error || meta.last_page > currentPage) {
          getRequest(nextPage);
          setHasMorePage(true);
          setPageNumber(nextPage);
        } else {
          setHasMorePage(false);
        }
      }
    };

    const getBaseUrl = isPayment => {
      if (isPayment) {
        if (Wdata.isAdmin) {
          return SUMMARY_PAYMENT_MANAGER;
        } else {
          return SUMMARY_PAYMENT_PETTY_CASHIER;
        }
      } else {
        if (Wdata.isAdmin) {
          return SUMMARY_RECEIVE_MANAGER;
        } else {
          return SUMMARY_RECEIVE_PETTY_CASHIER;
        }
      }
    };
    return (
      <React.Fragment>
        {!mainLoading && dataList && dataList.length > 0 && (
          <Table
            // icon="icon mapsa-list-of-items"
            // title="پرداخت‌ها و دریافت‌ها"
            header={PAYMENT_AND_RECEIVE_DETAIL_HEADER}
            rowOnClick={item => {
              const path = !item.is_payment
                ? `${getBaseUrl()}/${item.id}`
                : `${getBaseUrl(true)}/${item.id}`;
              history.push(path);
            }}
            hasPagination
            paginationClickHandler={() => paginationClickHandler()}
            hasMorePage={hasMorePage}
            pageNumber={pageNumber}
            data={normalizeData(
              dataList,
              PAYMENT_AND_RECEIVE,
              null,
              Wdata.PaymentImage,
              Wdata.ReceiveImage
            )}
          />
        )}
        {loading && (
          <div className="page-loading-container ">
            <BoxLoading />
          </div>
        )}
        {error && <ErrorHandle message={error} request={() => getRequest()} />}
      </React.Fragment>
    );
  };

  const mapStateToProps = store => {
    const reducer = store[Wdata.reducer_name];
    return {
      data: reducer.itemsObject.data,
      meta: reducer.itemsObject.meta,
      loading: reducer.itemsObjectLoading,
      error: reducer.itemsObjectError
    };
  };

  const mapDispatchToProps = dispatch => {
    return {
      getList: (id, pageNumber) => {
        dispatch(Wdata.getItems(id, pageNumber));
      }
    };
  };

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(TransactionsItem));
};
